import { Component } from '@angular/core';

@Component({
	selector: 'dl-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent {
	title = 'data-explorer';
}
